import {Component, OnInit} from '@angular/core';
import {DataStoreService} from "../shared/services/api/data-store.service";
import {Customer} from "../shared/models/customer";
import {Observable} from "rxjs";
import {JsonApiModel} from "angular2-jsonapi";
import {Router, ActivatedRoute} from "@angular/router";
import {FormControl} from "@angular/forms";
import {TableData, SearchConfiguration} from "../shared/components/data-table/data-table.component";
import {Site} from '../shared/models/site';

@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.css']
})
export class CustomerComponent implements OnInit {
  public static cachedCustomers: Customer[];

  public model = Site;

  constructor(private dataStore: DataStoreService,
              private activatedRoute: ActivatedRoute,
              private router: Router) {
  }

  ngOnInit() {
  }

  navigate(id: number) {
    this.router.navigate([id], {relativeTo: this.activatedRoute});
  }

}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/customer/customer.component.ts